module.exports = __webpack_public_path__ + "images/category_lp/home_appliance/banner_c048a4172667b6e975a447dcd6edbc58.png";